import { Flex, Text } from '@chakra-ui/react'
import { Trans } from '@lingui/react/macro'
import { usePostHog } from 'posthog-js/react'
import { type FC, useEffect } from 'react'

import { getDisplayMessage } from '../components/api/displayMessage'
import CapturiThemeProvider from '../components/CapturiThemeProvider'
import { setAmplitudeUserId } from '../utils/amplitude'
import { createState } from './createState'
import { logEvents } from './logEvents'
import { useSessionPersistence } from './sessionPersistence'
import { setOrganizationUid } from './sessionStore'
import { theme } from './theme'
import { usePuzzelEvents } from './usePuzzelEvents/usePuzzelEvents'
import { useQueuesWithCopilotSettings } from './useSettings'
import { Widget } from './Widget'

export const PuzzelWidget: FC = () => {
  const posthog = usePostHog()

  const params = new URLSearchParams(window.location.search)
  const copilotToken = params.get('copilotToken')
  const { data: settings, error } = useQueuesWithCopilotSettings(copilotToken)

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)

    const organizationUid = params.get('org')
    if (organizationUid) {
      posthog?.identify(organizationUid)
      setAmplitudeUserId(organizationUid)
      setOrganizationUid(organizationUid)
    }
  }, [posthog])

  const eventState = usePuzzelEvents()

  const state = createState({
    eventState,
    search: window.location.search,
    settings,
  })

  useSessionPersistence({
    sessionUid: eventState.data.sessionUid,
    queue: eventState.data.queue,
    customer: eventState.data.customer,
    callState: eventState.currentCallState,
    hasTranscription: eventState.data.hasTranscription,
    getTranscription: eventState.data.getTranscription,
  })

  useEffect(() => {
    logEvents({
      eventType: 'eventWidgetState',
      type: 'currentState',
      modules: state.modules,
      currentCallState: state.currentCallState,
      queue: state.data.queue,
      whitelistedQueues: settings?.queues || null,
      lockedQueues: settings?.lockedQueues || null,
    })
  }, [state, settings])

  if (error) {
    return (
      <CapturiThemeProvider theme={theme}>
        <Flex
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
        >
          <Text>
            <Trans>Something went wrong</Trans>
          </Text>
          <Text>{getDisplayMessage(error)}</Text>
        </Flex>
      </CapturiThemeProvider>
    )
  }
  return (
    <CapturiThemeProvider theme={theme}>
      <Widget state={state} />
    </CapturiThemeProvider>
  )
}
